import { Component, OnInit, ViewChild, TemplateRef, AfterViewInit } from '@angular/core';
import { UserService, SubAgency } from 'app/services/user.service';
import { TableColumn, CommonTableService } from 'app/services/common-table.service';
import { AdminService, UpdateCustomerProps } from 'app/services/admin.service';
import { CommonModalService } from 'app/services/common-modal.service';
import { ConfirmModalComponent, ConfirmModalData } from 'app/components/modal/confirm-modal/confirm-modal.component';
import { EditSubAgencyModalComponent, EditSubAgencyModalInput } from './edit-sub-agency-modal/edit-sub-agency-modal.component';
import { MatDialogConfig, MatDialogRef } from '@angular/material';
import { AddSubAgencyModalComponent, AddSubAgencyModalOutput } from './add-sub-agency-modal/add-sub-agency-modal.component';
import { AuthService } from 'app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { CommonFunctionService } from 'app/services/common-function.service';
import { AppSettings } from 'app/app.settings';
import { AppinfoService } from 'app/services/appinfo.service';
import { PaneControlService } from 'app/services/pane-control.service';

@Component({
  selector: 'app-config-sub-agencies',
  templateUrl: './config-sub-agencies.component.html',
  styleUrls: ['./config-sub-agencies.component.css', './../config-users/config-users.component.css']
})
export class ConfigSubAgenciesComponent implements OnInit, AfterViewInit {

	@ViewChild('operationsTempl', { static: false }) operationsTempl: TemplateRef<any>;

	public subAgencies: SubAgency[] = [];

	// rows without filter
	public unfilteredRows: any[] = []
	//
	public rows: any[] = [];
	public columns: TableColumn[] [];
	public selectedRows = [];

	public searchStr = '';

	private readonly agencyNameCol = 'agencyName';
	private readonly agencyAdminEmailCol = 'agencyEmail';
	public readonly agencyIdCol = 'agencyId';
	private readonly operationsCol = 'operations';
	public readonly isNewAgencyCol = 'isNewUser';
	constructor(
		private toastr: ToastrService,
		private adminService: AdminService,
		private appinfoService: AppinfoService,
		private authService: AuthService,
		private commonFunction: CommonFunctionService,
		private modalService: CommonModalService,
		private tableService: CommonTableService,
		private paneService: PaneControlService,
		private userService: UserService
	) { }

	public async removeSubAgency(agencyId) {
		const agency = this.subAgencies.find((a) => a.id === agencyId);
		const options = this.modalService.confirmModalOptions;
		const data: ConfirmModalData = {
			message: 'Are you sure you want to delete this sub agency -- ' + agency.name + '?'
		};
		options.data = data;
		const result = await this.modalService.openModalWindow(ConfirmModalComponent, options);
		if (result) {
			this.commonFunction.setLoadingSpinner(true);
			try {
				await this.adminService.deleteCustomer(agencyId);
				this.toastr.success('Successfully deleted.');
				this.updateSubAgenciesTable();
			} catch (err) {
				console.log(err);
			}
			this.commonFunction.setLoadingSpinner(false);
		}
	}
	public async editSubAgency(agencyId) {
		const agency = this.subAgencies.find((a) => a.id === agencyId);
		const data: EditSubAgencyModalInput = {
			shortName: agency.name
		};
		const options: MatDialogConfig = {
			data: data,
			width: '450px',
			height: '200px'
		};
		const result: UpdateCustomerProps = await this.modalService.openModalWindow(EditSubAgencyModalComponent, options);
		if (result && result !== agency.name) {
			this.adminService.updateCustomer(result, agency.id);
			this.updateSubAgenciesTable();
		}
	}
	public async addSubAgency() {
		const options: MatDialogConfig = {
			width: '730px',
			height: '650px'
		};
		const result: AddSubAgencyModalOutput = await this.modalService.openModalWindow(AddSubAgencyModalComponent, options);
		if (result) {
			this.commonFunction.setLoadingSpinner(true);
			try {
				const registerRsp = await this.authService.registerAgency(result.name, result.adminEmail, result.pw, result.desc, this.userService.customerInfo.id);
				await this.authService.sendVerifyEmail(result.adminEmail, result.name);
				// Different from LBPortal, AZGIV add subscription & userSubscription right after the agency is created.
				// AZGIV users don't deal with subscriptions which is only for Gistic management purpose
				const newCustomerId = registerRsp.data[0].cus_id;
				const newUserId = registerRsp.data[0].usr_id;
				// TODO
					// result.cusProps.customerShortName = result.name
				this.adminService.updateCustomer(result.cusProps, newCustomerId);

				// Using parent subscription instead of creating a new subscription
				const subId = this.userService.getUserInfo().subscriptionId;
				// const subscriptionRsp = await this.adminService.addSubscription(newCustomerId, AppSettings.appName, 'BASIC', newUserId, new Date(), 99999);
				const roleId = this.appinfoService.rolesByApp[AppSettings.appName].find((r) => r.desc === 'ADMINISTRATOR').rol_id;
				await this.adminService.addUserSubscription(newUserId, subId, roleId);
				this.toastr.info('An email has been sent for verification.');
			} catch (err) {
				console.log(err.message);
				this.toastr.error('Failed to add agency.');
			}
			this.commonFunction.setLoadingSpinner(false);
		}
	}
	public async updateSubAgenciesTable() {
		await this.authService.updateToken();
		this.subAgencies = this.userService.customerInfo.children;
		this.setRows();
	}
	public search() {
		this.rows = this.filterRows();
	}
	// Filter rows with searchStr
	private filterRows() {
		if (this.searchStr) {
			return this.unfilteredRows.filter((r) => {
				// Always show newSubAgency row
				if (r[this.isNewAgencyCol]) {
					return true;
				}
				if (r[this.agencyNameCol]) {
					return r[this.agencyNameCol].toLowerCase().indexOf(this.searchStr.toLowerCase()) > -1
				}
				return false;
			});
		} else {
			return this.unfilteredRows;
		}
	}
	private setRows() {
		const rows = [];
		this.subAgencies.forEach((a) => {
			const row: any = {};
			row[this.agencyNameCol] = a.name;
			row[this.agencyAdminEmailCol] = a.adminEmails.join();
			row[this.agencyIdCol] = a.id;
			rows.push(row);
		});
		// Add new sub agency row
		const newUserRow: any = {};
		newUserRow[this.isNewAgencyCol] = true;
		rows.push(newUserRow);
		this.unfilteredRows = rows;
		this.rows = this.filterRows();
	}
	// Set table columns
	private setColumns() {
		const columns = [];
		// Add agency name column
		const agencyNameCol = this.tableService.setNewColumn(this.agencyNameCol, 'Sub Agency Name', {
			skipGdoCheck: true,
			// width: 200,
			isNameKeepCase: true,
			headerAlign: 'L'
		});
		columns.push(agencyNameCol);
		// Add agency name column
		const adminEmailCol = this.tableService.setNewColumn(this.agencyAdminEmailCol, 'Admin Users', {
			skipGdoCheck: true,
			// width: 200,
			isNameKeepCase: true,
			headerAlign: 'L'
		});
		columns.push(adminEmailCol);
		// Add operations column
		const operationsCol = this.tableService.setNewColumn(this.operationsCol, ' ', {
			align: 'R',
			headerAlign: 'R',
			skipGdoCheck: true,
			cellTemplate: this.operationsTempl
		});
		columns.push(operationsCol);
		this.columns = columns;
	}
	ngOnInit() {
		// Tell paneControl current pane is switched to config, so that the highlighted menu item can change to config
		this.paneService.currPane.next({
			paneType: 'config',
			submenu: 'configSubAgencies'
		});
		this.subAgencies = this.userService.customerInfo.children;
	}
	ngAfterViewInit(): void {
		this.setColumns();
		this.setRows();
	}

}
